import { createSelector } from 'reselect';
import { SF_COVER_CATEGORIES } from '../../actions/sizotsaFuneralCover/types';
import { getSizotsaFuneralCover } from '.';
export const parentsInLawsRelations=[
    {
        code: 'Mother',
        description: 'Mother',
    },
    {
        code: 'Mother-in-law',
        description: 'Mother-in-law',
    },
    {
        code: 'Father',
        description: 'Father',
    },
    {
        code: 'Father-in-law',
        description: 'Father-in-law',
    },
    {
        code: 'Step-father',
        description: 'Step-father',
    },
    {
        code: 'Step-mother',
        description: 'Step-mother',
    },
    {
        code: 'Adoptive father',
        description: 'Adoptive father',
    },
    {
        code: 'Adoptive mother',
        description: 'Adoptive mother',
    },
]
export const extendedFamilyRelations=[
    {
        code: 'aunt',
        description: 'Aunt',
    },
    {
        code: 'Uncle',
        description: 'Uncle',
    },
    {
        code: 'Brother',
        description: 'Brother',
    },
    {
        code: 'Sister',
        description: 'Sister',
    },
    {
        code: 'Brother-in-law',
        description: 'Brother-in-law',
    },
    {
        code: 'Sister-in-law',
        description: 'Sister-in-law',
    },
    {
        code: 'Son-in-law',
        description: 'Son-in-law',
    },
    {
        code: 'Daughter-in-law',
        description: 'Daughter-in-law',
    },
    {
        code: 'Grand-father',
        description: 'Grand-father',
    },
    {
        code: 'Grand-mother',
        description: 'Grand-mother',
    },
    {
        code: 'Grand-son',
        description: 'Grand-son',
    },
    {
        code: 'Grand-daughter',
        description: 'Grand-daughter',
    },
    {
        code: 'Niece',
        description: 'Niece',
    },
    {
        code: 'First cousins',
        description: 'First cousins',
    },
    
    {
        code: 'Nephew',
        description: 'Nephew',
    },
    {
        code: 'Son',
        description: 'Son',
    },
    {
        code: 'Daughter',
        description: 'Daughter',
    },
    {
        code: 'Ex-husband',
        description: 'Ex-husband',
    },
    {
        code: 'Ex-wife',
        description: 'Ex-wife',
    },
]
const directFamilyRelations=[  {
    code: 'Child',
    description: 'Child',
},
{
    code: 'Spouse',
    description: 'Spouse',
},]
export const getReferenceData=createSelector(getSizotsaFuneralCover,(sizotsaFuneralCover)=>sizotsaFuneralCover.referenceData)

const getStateData=(feild)=>createSelector(getReferenceData,(referenceData)=>referenceData[feild])
export const getBanksReferenceData=getStateData('banks')
export const getBranchCodesReferenceData=getStateData('branchCodes')
export const getApiDetails=getStateData('apiDetails')
export const getPurchaseResponse = getStateData('purchaseServiceResponse');
export const getReferenceAgentCode = getStateData('agentCodeDetails');

export const getIsAgentExists = createSelector(
    getReferenceAgentCode,
    (agentCodeDetails) => {
        const { data={agentExists:null} }=agentCodeDetails
        return data?.agentExists === "YES"
    }
);
export const getTermsAndConditions=createSelector(getReferenceData, (referenceData) => referenceData.termsandConditions);

export const getQuoteRefernceData = () => ({
    displayCoverCategories: [
      ...directFamilyRelations,
        {
            code: SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
            description: 'My Parents and Parents In-law',
        },
        {
            code: SF_COVER_CATEGORIES.EXTENDED_FAMILY,
            description: 'My Extended Family',
        },
    ],
    quoteDisplayCoverCategories: [
        {
            code: SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
            description: 'My Parents and Parents In-law',
        },
        {
            code: SF_COVER_CATEGORIES.EXTENDED_FAMILY,
            description: 'My Extended Family',
        },
    ],
    displayParentsandInLaws: parentsInLawsRelations,
    displayExtendedFamilyMembers: extendedFamilyRelations,
    referenceTitles: [
        {
            code: 'Mr.',
            description: 'Mr.',
        },
        {
            code: 'Mrs.',
            description: 'Mrs.',
        },
        {
            code: 'Miss.',
            description: 'Miss.',
        },
    ],
    beneficiaryRelations:[
        ...directFamilyRelations,
        ...parentsInLawsRelations,
        ...extendedFamilyRelations,
    ],
    yesNoReferenceData:[ {
        code: 'Yes',
        description: 'Yes',
    },
    {
        code: 'No',
        description: 'No',
    },
],
    genderReferenceData:[
         { description: 'Male', code: 'male' },
         { description: 'Female', code: 'female' },

    ],
     referenceHearAboutUs:[
        {
            code: 'online',
            description: 'Online',
        },
        {
            code: 'onRadio',
            description: 'On radio',
        },
        {
            code: 'onTv',
            description: 'On Tv',
        },
        {
            code: 'fromBillboard',
            description: 'From a billboard',
        },
        {
            code: 'fromSomeone',
            description: 'From someone I know',
        },
        {
            code: 'omEmployee',
            description: 'Old mutual employee',
        },
        {
            code: 'broker',
            description: 'Broker/Agent',
        },
        {
            code: 'other',
            description: 'Other',
        },
    ],
    referenceOnlinePlatform:[
        {
            code: 'facebook',
            description: 'Facebook',
        },
        {
            code: 'linkedIn',
            description: 'LinkedIn',
        },
        {
            code: 'twitter/X',
            description: 'Twitter/X',
        },
        {
            code: 'youTube',
            description: 'YouTube',
        },
        {
            code: 'googleSearch',
            description: 'Google Search',
        },
       
    ],
    referenceNationality: [
        { description: 'Afghanistan', code: 'Afghanistan' },
        { description: 'Albania', code: 'Albania' },
        { description: 'Algeria', code: 'Algeria' },
        { description: 'Andorra', code: 'Andorra' },
        { description: 'Angola', code: 'Angola' },
        { description: 'Anguilla', code: 'Anguilla' },
        { description: 'Antigua And Barbuda', code: 'Antigua And Barbuda' },
        { description: 'Argentina', code: 'Argentina' },
        { description: 'Armenia', code: 'Armenia' },
        { description: 'Aruba', code: 'Aruba' },
        { description: 'Jordan', code: 'Jordan' },
        { description: 'Kazakhstan', code: 'Kazakhstan' },
        { description: 'Kenya', code: 'Kenya' },
        { description: 'Kiribati', code: 'Kiribati' },
        { description: 'Korea, Republic (South)', code: 'Korea, Republic (South)' },
        { description: 'Kosovo', code: 'Kosovo' },
        { description: 'Kuwait', code: 'Kuwait' },
        { description: 'Laos', code: 'Laos' },
        { description: 'Latvia', code: 'Latvia' },
        { description: 'Ascension And St-Helena', code: 'Ascension And St-Helena' },
        { description: 'Lebanon', code: 'Lebanon' },
        { description: 'Lesotho', code: 'Lesotho' },
        { description: 'Liberia', code: 'Liberia' },
        { description: 'Libya', code: 'Libya' },
        { description: 'Lithuania', code: 'Lithuania' },
        { description: 'Luxemburg', code: 'Luxemburg' },
        { description: 'Macao', code: 'Macao' },
        { description: 'Macedonia', code: 'Macedonia' },
        { description: 'Madagascar', code: 'Madagascar' },
        { description: 'Malawi', code: 'Malawi' },
        { description: 'Australia', code: 'Australia' },
        { description: 'Malaysia', code: 'Malaysia' },
        { description: 'Maldives', code: 'Maldives' },
        { description: 'Mali', code: 'Mali' },
        { description: 'Malta', code: 'Malta' },
        { description: 'Martinique', code: 'Martinique' },
        { description: 'Mauritania', code: 'Mauritania' },
        { description: 'Mauritius', code: 'Mauritius' },
        { description: 'Mexico', code: 'Mexico' },
        { description: 'Moldova', code: 'Moldova' },
        { description: 'Austria', code: 'Austria' },
        { description: 'Mongolia', code: 'Mongolia' },
        { description: 'Montenegro', code: 'Montenegro' },
        { description: 'Montserrat', code: 'Montserrat' },
        { description: 'Mozambique', code: 'Mozambique' },
        { description: 'Myanmar', code: 'Myanmar' },
        { description: 'Namibia', code: 'Namibia' },
        { description: 'Nauru', code: 'Nauru' },
        { description: 'Nepal', code: 'Nepal' },
        { description: 'Netherlands', code: 'Netherlands' },
        { description: 'Azerbaidjan', code: 'Azerbaidjan' },
        { description: 'Netherlands Antilles', code: 'Netherlands Antilles' },
        { description: 'New Caledonia', code: 'New Caledonia' },
        { description: 'New Zealand', code: 'New Zealand' },
        { description: 'Nicaragua', code: 'Nicaragua' },
        { description: 'Niger', code: 'Niger' },
        { description: 'Nigeria', code: 'Nigeria' },
        { description: 'Niu Island', code: 'Niu Island' },
        { description: 'North Korea', code: 'North Korea' },
        { description: 'Norway', code: 'Norway' },
        { description: 'Oman', code: 'Oman' },
        { description: 'Bahamas', code: 'Bahamas' },
        { description: 'Pakistan', code: 'Pakistan' },
        { description: 'Panama', code: 'Panama' },
        { description: 'Papua New Guinea', code: 'Papua New Guinea' },
        { description: 'Paraguay', code: 'Paraguay' },
        { description: 'Peru', code: 'Peru' },
        { description: 'Philippines', code: 'Philippines' },
        { description: 'Pitcairn Islands', code: 'Pitcairn Islands' },
        { description: 'Poland', code: 'Poland' },
        { description: 'Portugal', code: 'Portugal' },
        { description: 'Qatar', code: 'Qatar' },
        { description: 'Bahrain', code: 'Bahrain' },
        { description: 'Reunion', code: 'Reunion' },
        { description: 'Romania', code: 'Romania' },
        { description: 'Russia', code: 'Russia' },
        { description: 'Rwanda', code: 'Rwanda' },
        { description: 'Samoa', code: 'Samoa' },
        { description: 'Sao Tome And Principe', code: 'Sao Tome And Principe' },
        { description: 'Saudi Arabia', code: 'Saudi Arabia' },
        { description: 'Senegal', code: 'Senegal' },
        { description: 'Serbia', code: 'Serbia' },
        { description: 'Seychelles', code: 'Seychelles' },
        { description: 'Bangladesh', code: 'Bangladesh' },
        { description: 'Sierra Leone', code: 'Sierra Leone' },
        { description: 'Singapore', code: 'Singapore' },
        { description: 'Slovakia', code: 'Slovakia' },
        { description: 'Slovenia', code: 'Slovenia' },
        { description: 'Solomon Islands', code: 'Solomon Islands' },
        { description: 'Somalia', code: 'Somalia' },
        { description: 'South Africa', code: 'South Africa' },
        { description: 'Spain', code: 'Spain' },
        { description: 'Sri Lanka', code: 'Sri Lanka' },
        { description: 'St Kitts And Nevis', code: 'St Kitts And Nevis' },
        { description: 'Barbados', code: 'Barbados' },
        { description: 'St Lucia', code: 'St Lucia' },
        { description: 'St Pierre And Miquelon', code: 'St Pierre And Miquelon' },
        { description: 'St Vincent And The Grenadines', code: 'St Vincent And The Grenadines' },
        { description: 'Sudan', code: 'Sudan' },
        { description: 'South Sudan', code: 'South Sudan' },
        { description: 'Suriname', code: 'Suriname' },
        { description: 'Turks & Caicos Islands', code: 'Turks & Caicos Islands' },
        { description: 'Tuvalu', code: 'Tuvalu' },
        { description: 'Uganda', code: 'Uganda' },
        { description: 'Ukraine', code: 'Ukraine' },
        { description: 'United Arab Emirates', code: 'United Arab Emirates' },
        { description: 'Uruguay', code: 'Uruguay' },
        { description: 'Usa', code: 'Usa' },
        { description: 'Uzbekistan', code: 'Uzbekistan' },
        { description: 'Belize', code: 'Belize' },
        { description: 'Vanuatu', code: 'Vanuatu' },
        { description: 'Vatican', code: 'Vatican' },
        { description: 'Venezuela', code: 'Venezuela' },
        { description: 'Vietnam', code: 'Vietnam' },
        { description: 'Wallis And Futuna Islands', code: 'Wallis And Futuna Islands' },
        { description: 'Yemen', code: 'Yemen' },
        { description: 'Zambia', code: 'Zambia' },
        { description: 'Zimbabwe', code: 'Zimbabwe' },
        { description: 'Benin', code: 'Benin' },
        { description: 'Bermuda', code: 'Bermuda' },
        { description: 'Bhutan', code: 'Bhutan' },
        { description: 'Bolivia', code: 'Bolivia' },
        { description: 'Bosnia Herzegovina', code: 'Bosnia Herzegovina' },
        { description: 'Botswana', code: 'Botswana' },
        { description: 'Brazil', code: 'Brazil' },
        { description: 'British Virgin Island', code: 'British Virgin Island' },
        { description: 'Brunei Darussalam', code: 'Brunei Darussalam' },
        { description: 'Bulgaria', code: 'Bulgaria' },
        { description: 'Burkina Faso', code: 'Burkina Faso' },
        { description: 'Burundi', code: 'Burundi' },
        { description: 'Cambodia', code: 'Cambodia' },
        { description: 'Cameroon', code: 'Cameroon' },
        { description: 'Canada', code: 'Canada' },
        { description: 'Cape Verde', code: 'Cape Verde' },
        { description: 'Cayman Islands', code: 'Cayman Islands' },
        { description: 'Central African Republic', code: 'Central African Republic' },
        { description: 'Chad', code: 'Chad' },
        { description: 'Chile', code: 'Chile' },
        { description: 'China', code: 'China' },
        { description: 'Colombia', code: 'Colombia' },
        { description: 'Comoros', code: 'Comoros' },
        { description: 'Congo', code: 'Congo' },
        { description: 'Cook Islands', code: 'Cook Islands' },
        { description: 'Costa Rica', code: 'Costa Rica' },
        { description: 'Croatia', code: 'Croatia' },
        { description: 'Cuba', code: 'Cuba' },
        { description: 'Cyprus', code: 'Cyprus' },
        { description: 'Czech Republic', code: 'Czech Republic' },
        { description: 'Denmark', code: 'Denmark' },
        { description: 'Djibouti', code: 'Djibouti' },
        { description: 'Dominica', code: 'Dominica' },
        { description: 'Dominican Republic', code: 'Dominican Republic' },
        { description: 'Ecuador', code: 'Ecuador' },
        { description: 'Egypt', code: 'Egypt' },
        { description: 'El Salvador', code: 'El Salvador' },
        { description: 'Equatorial Guinea', code: 'Equatorial Guinea' },
        { description: 'Eritrea', code: 'Eritrea' },
        { description: 'Estonia', code: 'Estonia' },
        { description: 'Ethiopia', code: 'Ethiopia' },
        { description: 'Falkland Islands', code: 'Falkland Islands' },
        { description: 'Faröe Islands', code: 'Faröe Islands' },
        { description: 'Fiji', code: 'Fiji' },
        { description: 'Finland', code: 'Finland' },
        { description: 'France', code: 'France' },
        { description: 'French Guiana', code: 'French Guiana' },
        { description: 'French Polynesia', code: 'French Polynesia' },
        { description: 'Gabon', code: 'Gabon' },
        { description: 'Gambia', code: 'Gambia' },
        { description: 'Georgia', code: 'Georgia' },
        { description: 'Germany', code: 'Germany' },
        { description: 'Ghana', code: 'Ghana' },
        { description: 'Gibraltar', code: 'Gibraltar' },
        { description: 'Great Britain', code: 'Great Britain' },
        { description: 'Greece', code: 'Greece' },
        { description: 'Greenland', code: 'Greenland' },
        { description: 'Grenada', code: 'Grenada' },
        { description: 'Guadeloupe', code: 'Guadeloupe' },
        { description: 'Guatemala', code: 'Guatemala' },
        { description: 'Guinea', code: 'Guinea' },
        { description: 'Guinea-Bissau', code: 'Guinea-Bissau' },
        { description: 'Guyana', code: 'Guyana' },
        { description: 'Haiti', code: 'Haiti' },
        { description: 'Honduras', code: 'Honduras' },
        { description: 'Hong Kong', code: 'Hong Kong' },
        { description: 'Hungary', code: 'Hungary' },
        { description: 'Iceland', code: 'Iceland' },
        { description: 'India', code: 'India' },
        { description: 'Indonesia', code: 'Indonesia' },
        { description: 'Iran', code: 'Iran' },
        { description: 'Iraq', code: 'Iraq' },
        { description: 'Ireland', code: 'Ireland' },
        { description: 'Israel', code: 'Israel' },
        { description: 'Italy', code: 'Italy' },
        { description: 'Ivory Coast', code: 'Ivory Coast' },
        { description: 'Jamaica', code: 'Jamaica' },
        { description: 'Japan', code: 'Japan' },
        { description: 'Eswatini', code: 'Eswatini' },
        { description: 'Sweden', code: 'Sweden' },
        { description: 'Switzerland', code: 'Switzerland' },
        { description: 'Syria', code: 'Syria' },
        { description: 'Taiwan', code: 'Taiwan' },
        { description: 'Belarus', code: 'Belarus' },
        { description: 'Tajikistan', code: 'Tajikistan' },
        { description: 'Tanzania', code: 'Tanzania' },
        { description: 'Thailand', code: 'Thailand' },
        { description: 'Timor-Leste', code: 'Timor-Leste' },
        { description: 'Togo', code: 'Togo' },
        { description: 'Tokelau Islands', code: 'Tokelau Islands' },
        { description: 'Tonga', code: 'Tonga' },
        { description: 'Trinidad And Tobago', code: 'Trinidad And Tobago' },
        { description: 'Tristan Da Cunha', code: 'Tristan Da Cunha' },
        { description: 'Tunisia', code: 'Tunisia' },
        { description: 'Belgium', code: 'Belgium' },
        { description: 'Turkey', code: 'Turkey' },
        { description: 'Turkmenistan', code: 'Turkmenistan' },
    ],
    referenceBirthCountries: [
         {code: 'Afghanistan', description: 'Afghanistan'},
         {code: 'Albania', description: 'Albania'},
         {code: 'Algeria', description: 'Algeria'},
         {code: 'Andorra', description: 'Andorra'},
         {code: 'Angola', description: 'Angola'},
         {code: 'Anguilla', description: 'Anguilla'},
         {code: 'Antigua And Barbuda', description: 'Antigua And Barbuda'},
         {code: 'Argentina', description: 'Argentina'},
         {code: 'Armenia', description: 'Armenia'},
         {code: 'Aruba', description: 'Aruba'},
         {code: 'Jordan', description: 'Jordan'},
         {code: 'Kazakhstan', description: 'Kazakhstan'},
         {code: 'Kenya', description: 'Kenya'},
         {code: 'Kiribati', description: 'Kiribati'},
         {code: 'Korea, Republic (South)', description: 'Korea, Republic (South)'},
         {code: 'Kosovo', description: 'Kosovo'},
         {code: 'Kuwait', description: 'Kuwait'},
         {code: 'Kyrgyzstan', description: 'Kyrgyzstan'},
         {code: 'Laos', description: 'Laos'},
         {code: 'Latvia', description: 'Latvia'},
         {code: 'Ascension And St-Helena', description: 'Ascension And St-Helena'},
         {code: 'Lebanon', description: 'Lebanon'},
         {code: 'Lesotho', description: 'Lesotho'},
         {code: 'Liberia', description: 'Liberia'},
         {code: 'Libya', description: 'Libya'},
         {code: 'Lithuania', description: 'Lithuania'},
         {code: 'Luxemburg', description: 'Luxemburg'},
         {code: 'Macao', description: 'Macao'},
         {code: 'Macedonia', description: 'Macedonia'},
         {code: 'Madagascar', description: 'Madagascar'},
         {code: 'Malawi', description: 'Malawi'},
         {code: 'Australia', description: 'Australia'},
         {code: 'Malaysia', description: 'Malaysia'},
         {code: 'Maldives', description: 'Maldives'},
         {code: 'Mali', description: 'Mali'},
         {code: 'Malta', description: 'Malta'},
         {code: 'Martinique', description: 'Martinique'},
         {code: 'Mauritania', description: 'Mauritania'},
         {code: 'Mauritius', description: 'Mauritius'},
         {code: 'Mayotte', description: 'Mayotte'},
         {code: 'Mexico', description: 'Mexico'},
         {code: 'Moldova', description: 'Moldova'},
         {code: 'Austria', description: 'Austria'},
         {code: 'Mongolia', description: 'Mongolia'},
         {code: 'Montenegro', description: 'Montenegro'},
         {code: 'Montserrat', description: 'Montserrat'},
         {code: 'Morocco', description: 'Morocco'},
         {code: 'Mozambique', description: 'Mozambique'},
         {code: 'Myanmar', description: 'Myanmar'},
         {code: 'Namibia', description: 'Namibia'},
         {code: 'Nauru', description: 'Nauru'},
         {code: 'Nepal', description: 'Nepal'},
         {code: 'Netherlands', description: 'Netherlands'},
         {code: 'Azerbaidjan', description: 'Azerbaidjan'},
         {code: 'Netherlands Antilles', description: 'Netherlands Antilles'},
         {code: 'New Caledonia', description: 'New Caledonia'},
         {code: 'New Zealand', description: 'New Zealand'},
         {code: 'Nicaragua', description: 'Nicaragua'},
         {code: 'Niger', description: 'Niger'},
         {code: 'Nigeria', description: 'Nigeria'},
         {code: 'Niu Island', description: 'Niu Island'},
         {code: 'North Korea', description: 'North Korea'},
         {code: 'Norway', description: 'Norway'},
         {code: 'Oman', description: 'Oman'},
         {code: 'Bahamas', description: 'Bahamas'},
         {code: 'Pakistan', description: 'Pakistan'},
         {code: 'Panama', description: 'Panama'},
         {code: 'Papua New Guinea', description: 'Papua New Guinea'},
         {code: 'Paraguay', description: 'Paraguay'},
         {code: 'Peru', description: 'Peru'},
         {code: 'Philippines', description: 'Philippines'},
         {code: 'Pitcairn Islands', description: 'Pitcairn Islands'},
         {code: 'Poland', description: 'Poland'},
         {code: 'Portugal', description: 'Portugal'},
         {code: 'Qatar', description: 'Qatar'},
         {code: 'Bahrain', description: 'Bahrain'},
         {code: 'Reunion', description: 'Reunion'},
         {code: 'Romania', description: 'Romania'},
         {code: 'Russia', description: 'Russia'},
         {code: 'Rwanda', description: 'Rwanda'},
         {code: 'Samoa', description: 'Samoa'},
         {code: 'Sao Tome And Principe', description: 'Sao Tome And Principe'},
         {code: 'Saudi Arabia', description: 'Saudi Arabia'},
         {code: 'Senegal', description: 'Senegal'},
         {code: 'Serbia', description: 'Serbia'},
         {code: 'Seychelles', description: 'Seychelles'},
         {code: 'Bangladesh', description: 'Bangladesh'},
         {code: 'Sierra Leone', description: 'Sierra Leone'},
         {code: 'Singapore', description: 'Singapore'},
         {code: 'Slovakia', description: 'Slovakia'},
         {code: 'Slovenia', description: 'Slovenia'},
         {code: 'Solomon Islands', description: 'Solomon Islands'},
         {code: 'Somalia', description: 'Somalia'},
         {code: 'South Africa', description: 'South Africa'},
         {code: 'Spain', description: 'Spain'},
         {code: 'Sri Lanka', description: 'Sri Lanka'},
         {code: 'St Kitts And Nevis', description: 'St Kitts And Nevis'},
         {code: 'Barbados', description: 'Barbados'},
         {code: 'St Lucia', description: 'St Lucia'},
         {code: 'St Pierre And Miquelon', description: 'St Pierre And Miquelon'},
         {code: 'St Vincent And The Grenadines', description: 'St Vincent And The Grenadines'},
         {code: 'South Sudan ', description: 'South Sudan '},
         {code: 'Suriname', description: 'Suriname'},
         {code: 'Eswatini', description: 'Eswatini'},
         {code: 'Sweden', description: 'Sweden'},
         {code: 'Switzerland', description: 'Switzerland'},
         {code: 'Syria', description: 'Syria'},
         {code: 'Taiwan', description: 'Taiwan'},
         {code: 'Belarus', description: 'Belarus'},
         {code: 'Tajikistan', description: 'Tajikistan'},
         {code: 'Tanzania', description: 'Tanzania'},
         {code: 'Thailand', description: 'Thailand'},
         {code: 'Timor-Leste', description: 'Timor-Leste'},
         {code: 'Togo', description: 'Togo'},
         {code: 'Tokelau Islands', description: 'Tokelau Islands'},
         {code: 'Tonga', description: 'Tonga'},
         {code: 'Trinidad And Tobago', description: 'Trinidad And Tobago'},
         {code: 'Tristan Da Cunha', description: 'Tristan Da Cunha'},
         {code: 'Tunisia', description: 'Tunisia'},
         {code: 'Belgium', description: 'Belgium'},
         {code: 'Turkey', description: 'Turkey'},
         {code: 'Turkmenistan', description: 'Turkmenistan'},
         {code: 'Turks & Caicos Islands', description: 'Turks & Caicos Islands'},
         {code: 'Tuvalu', description: 'Tuvalu'},
         {code: 'Uganda', description: 'Uganda'},
         {code: 'Ukraine', description: 'Ukraine'},
         {code: 'United Arab Emirates', description: 'United Arab Emirates'},
         {code: 'Uruguay', description: 'Uruguay'},
         {code: 'United States Of America', description: 'United States Of America'},
         {code: 'Uzbekistan', description: 'Uzbekistan'},
         {code: 'Belize', description: 'Belize'},
         {code: 'Vanuatu', description: 'Vanuatu'},
         {code: 'Vatican', description: 'Vatican'},
         {code: 'Venezuela', description: 'Venezuela'},
         {code: 'Vietnam', description: 'Vietnam'},
         {code: 'Wallis And Futuna Islands', description: 'Wallis And Futuna Islands'},
         {code: 'Yemen', description: 'Yemen'},
         {code: 'Zambia', description: 'Zambia'},
         {code: 'Zimbabwe', description: 'Zimbabwe'},
         {code: 'Japan', description: 'Japan'},
         {code: 'Gulf Co-operation Council', description: 'Gulf Co-operation Council'},
         {code: 'Benin', description: 'Benin'},
         {code: 'UK', description: 'UK'},
         {code: 'Bermuda', description: 'Bermuda'},
         {code: 'Bhutan', description: 'Bhutan'},
         {code: 'Bolivia', description: 'Bolivia'},
         {code: 'Bosnia Herzegovina', description: 'Bosnia Herzegovina'},
         {code: 'Botswana', description: 'Botswana'},
         {code: 'Brazil', description: 'Brazil'},
         {code: 'British Virgin Island', description: 'British Virgin Island'},
         {code: 'Brunei Darussalam', description: 'Brunei Darussalam'},
         {code: 'Bulgaria', description: 'Bulgaria'},
         {code: 'Burkina Faso', description: 'Burkina Faso'},
         {code: 'Burundi', description: 'Burundi'},
         {code: 'Cambodia', description: 'Cambodia'},
         {code: 'Cameroon', description: 'Cameroon'},
         {code: 'Canada', description: 'Canada'},
         {code: 'Cape Verde', description: 'Cape Verde'},
         {code: 'Cayman Islands', description: 'Cayman Islands'},
         {code: 'Central African Republic', description: 'Central African Republic'},
         {code: 'Chad', description: 'Chad'},
         {code: 'Chile', description: 'Chile'},
         {code: 'China', description: 'China'},
         {code: 'Colombia', description: 'Colombia'},
         {code: 'Comoros', description: 'Comoros'},
         {code: 'Congo', description: 'Congo'},
         {code: 'Cook Islands', description: 'Cook Islands'},
         {code: 'Costa Rica', description: 'Costa Rica'},
         {code: 'Croatia', description: 'Croatia'},
         {code: 'Cuba', description: 'Cuba'},
         {code: 'Cyprus', description: 'Cyprus'},
         {code: 'Czech Republic', description: 'Czech Republic'},
         {code: 'Denmark', description: 'Denmark'},
         {code: 'Djibouti', description: 'Djibouti'},
         {code: 'Dominica', description: 'Dominica'},
         {code: 'Dominican Republic', description: 'Dominican Republic'},
         {code: 'Ecuador', description: 'Ecuador'},
         {code: 'Egypt', description: 'Egypt'},
         {code: 'El Salvador', description: 'El Salvador'},
         {code: 'Equatorial Guinea', description: 'Equatorial Guinea'},
         {code: 'Eritrea', description: 'Eritrea'},
         {code: 'Estonia', description: 'Estonia'},
         {code: 'Ethiopia', description: 'Ethiopia'},
         {code: 'Falkland Islands', description: 'Falkland Islands'},
         {code: 'Faröe Islands', description: 'Faröe Islands'},
         {code: 'Fiji', description: 'Fiji'},
         {code: 'Finland', description: 'Finland'},
         {code: 'France', description: 'France'},
         {code: 'French Guiana', description: 'French Guiana'},
         {code: 'French Polynesia', description: 'French Polynesia'},
         {code: 'Gabon', description: 'Gabon'},
         {code: 'Gambia', description: 'Gambia'},
         {code: 'Georgia', description: 'Georgia'},
         {code: 'Germany', description: 'Germany'},
         {code: 'Ghana', description: 'Ghana'},
         {code: 'Gibraltar', description: 'Gibraltar'},
         {code: 'Great Britain', description: 'Great Britain'},
         {code: 'Greece', description: 'Greece'},
         {code: 'Greenland', description: 'Greenland'},
         {code: 'Grenada', description: 'Grenada'},
         {code: 'Guadeloupe', description: 'Guadeloupe'},
         {code: 'Guatemala', description: 'Guatemala'},
         {code: 'Guinea', description: 'Guinea'},
         {code: 'Guinea-Bissau', description: 'Guinea-Bissau'},
         {code: 'Guyana', description: 'Guyana'},
         {code: 'Haiti', description: 'Haiti'},
         {code: 'Honduras', description: 'Honduras'},
         {code: 'Hong Kong', description: 'Hong Kong'},
         {code: 'Hungary', description: 'Hungary'},
         {code: 'Iceland', description: 'Iceland'},
         {code: 'India', description: 'India'},
         {code: 'Indonesia', description: 'Indonesia'},
         {code: 'Iran', description: 'Iran'},
         {code: 'Iraq', description: 'Iraq'},
         {code: 'Ireland', description: 'Ireland'},
         {code: 'Israel', description: 'Israel'},
         {code: 'Italy', description: 'Italy'},
         {code: 'Ivory Coast', description: 'Ivory Coast'},
         {code: 'Jamaica', description: 'Jamaica'},
         {code: 'European Commission', description: 'European Commission'}
     ],
});


